import * as urlUtils from 'utils/Url';


export function getPathAffiliateProgram(qs={}) {
  return urlUtils.appendQueryString(`/affiliate-program`, qs);
}

export function getPathAffiliateCoupons(qs={}) {
  return urlUtils.appendQueryString(`/affiliate-coupons`, qs);
}

export function getPathAffiliateReferrals(qs={}) {
  return urlUtils.appendQueryString(`/affiliate-referrals`, qs);
}


